"use client";

import React, { useState } from "react";
import { Box, Button, Card, Chip, Grow, Icon, IconButton, LinearProgress, Stack, SwipeableDrawer, Typography } from "@mui/material";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import { Close } from "@mui/icons-material";
import { Color } from "@/__generated__/sdk";
import { useSiteSearchContext } from "./SiteSearchContext";
import _ from "lodash";

export default function MobileFilterHasOfferChip() {
  const { isPending, hasOffer, handleHasOfferChange } = useSiteSearchContext();
  return (
    <>
      <Chip
        variant={hasOffer ? "filled" : "outlined"}
        onClick={() => {
          handleHasOfferChange(!Boolean(hasOffer));
        }}
        {...(hasOffer && {
          color: "primary",
          onDelete: () => {
            handleHasOfferChange(!Boolean(hasOffer));
          },
        })}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2"> تخفیف دار</Typography>
          </Box>
        }
      ></Chip>
    </>
  );
}
